<!-- link -->
<template>
  <div class="miniliink" :class="['miniliink', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <div class="miniliink-box">
      <img class="pxind" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/minilinkUpgradePage.png" alt="" />
      <h3 v-if="type === 0" class="desc">敬请期待</h3>
      <h3 v-if="type === 1" class="desc">专升本在线学习平台</h3>
      <p v-if="type === 0" class="holding">小程序即将上线...</p>
      <button v-if="type === 1" @click="gostudy">进入小程序</button>
    </div>

  </div>
</template>

<script>
import { miniSchemeUrl } from '@/utils/common';
export default {
  data() {
    return {
      type: 0 // 0：未上线 1：已上线
    };
  },
  components: {},
  mounted() {
    // this.getSchemeUrl();
  },
  methods: {
    gostudy() {
      this.getSchemeUrl()
    },
    async getSchemeUrl() {
      const schemeLink= await  miniSchemeUrl('wxb4e3ec594f567a34','pages/home/home')
      window.location.href=schemeLink;
    },
  },
};
</script>

<style lang="scss" scoped>
.holding{
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #999999;
  line-height: 40px;
  font-style: normal;
}
.desc{
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 36px;
  color: #333333;
  line-height: 51px;
  font-style: normal;
  margin-top: 29px;
  margin-bottom: 7px;
}
.inApp {
  padding-top: 20px !important;
}

.miniliink {
  width: 100%;
  height: 100vh;
  // padding-top: 101px;
  // padding-bottom: 210px;
  background: #f9f9f9;
  user-select: none;
  overflow: hidden;

  .miniliink-box {
    text-align: center;
    margin-top: 297px;
  }

  button {
    width: 293px;
    height: 65px;
    background: #FF7F41;
    border-radius: 45px;
    font-weight: 500;
    font-size: 29px;
    color: #FFFFFF;
    margin-top: 87px;
  }

  .pxind {
    display: block;
    margin: 0 auto;
    width: 200px;
    // height: 200px;
    border-radius: 50%;
  }
}
</style>
